import { CSSProperties, FC, PropsWithChildren } from 'react';
import classes from './styles/listTiles.module.css';

const ListTiles: FC<PropsWithChildren<{ style?: CSSProperties }>> = ({ children, style }) => {
	return (
		<ul
			className={classes.root}
			style={style}
		>
			{children}
		</ul>
	);
};

export { ListTiles };
